<script>
export default {
  data() {
    return {
      animateStyles: [
        {
          type: "type1",
          list: [
            {
              name: "飞入",
              animateType: "fadeIn",
              triggerType: "",
              animateClass: "cx_animate__fadeIn_left",
              variable: null,
              direction: "left",
              animateDuration: 1000, //单位ms
              animateDelay: 200,
              animationIterationCount: 1,
              iconClass: "icon-portal-fly"
            },
            {
              name: "移动",
              animateType: "move",
              triggerType: "",
              variable: {
                Left: "100px",
                Top: "100px"
              },
              animateClass: "cx_animate__move",
              animateDuration: 1000, //单位ms
              animateDelay: 200,
              animationIterationCount: 1,
              iconClass: "icon-portal-move"
            },
            {
              name: "变换",
              animateType: "rotateScale",
              triggerType: "",
              variable: {
                Rotate: "90deg",
                Scale: 1.5
              },
              animateClass: "cx_animate__rotate_scale",
              animateDuration: 1000, //单位ms
              animateDelay: 200,
              animationIterationCount: 1,
              iconClass: "icon-portal-scale"
            }
          ]
        },
        {
          type: "type2",
          list: [
            {
              name: "透明度",
              animateType: "opacity",
              triggerType: "",
              variable: {
                Opacity: 0.5
              },
              animateClass: "cx_animate__opacity",
              animateLeaveClass: "cx_animate__opacity",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-opacity"
            }
          ]
        },
      ],
      hoverAnimateStyles: [
        {
          type: "type1",
          list: [
            {
              name: "飞入",
              animateType: "fadeIn",
              triggerType: "hover",
              animateClass: "cx_hover__fadeIn_left",
              animateLeaveClass: "cx_hover_leave__fadeIn_left",
              variable: null,
              direction: "left",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-fly"
            },
            {
              name: "移动",
              animateType: "move",
              triggerType: "hover",
              variable: {
                hoverLeft: "100px",
                hoverTop: "100px"
              },
              animateClass: "cx_hover__move",
              animateLeaveClass: "cx_hover_leave__move",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-move"
            },
            {
              name: "变换",
              animateType: "rotateScale",
              triggerType: "hover",
              variable: {
                hoverRotate: "90deg",
                hoverScale: 1.5
              },
              animateClass: "cx_hover__rotate_scale",
              animateLeaveClass: "cx_hover_leave__rotate_scale",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-scale"
            },
            {
              name: "图片缩放",
              animateType: "imageScale",
              triggerType: "hover",
              variable: {
                hoverImageScale: 1.5
              },
              animateClass: "cx_hover__image_scale",
              animateLeaveClass: "cx_hover_leave__image_scale",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-scale--picture"
            },
            {
              name: "图标替换",
              animateType: "iconReplace",
              triggerType: "hover",
              icon:{
                src:'',
                type: 'icon',
                color:'#000',
                colorIsThemeColor: false
              },
              variable: {
                hoverIconSrcType: `options_iconSrcType_0`,  // 图标类型 0 是iconSrc   1是hoverIconSrc  2是clickIconSrc
                hoverIconColor: '#fff',
              },
              animateClass: "cx_hover__icon_replace",
              animateLeaveClass: "cx_hover_leave__icon_replace",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-replace"
            }
          ]
        },
        {
          type: "type2",
          list: [
            {
              name: "文字颜色",
              animateType: "fontColor",
              triggerType: "hover",
              variable: {
                // hoverColor: "rgb(194,52,52)"
                hoverColor: "var_Color_page.themeColor"
              },
              animateClass: "cx_hover__fontColor",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-color"
            },
            {
              name: "文字大小",
              animateType: "fontSize",
              triggerType: "hover",
              variable: {
                hoverFontSize: "18px"
              },
              animateClass: "cx_hover__fontSize",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-text-2"
            },
            {
              name: "文字粗细",
              animateType: "fontWeight",
              triggerType: "hover",
              variable: {
                hoverFontWeight: "600"
              },
              animateClass: "cx_hover__fontWeight",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-text-bold1"
            }
          ]
        },
        {
          type: "type3",
          list: [
            {
              name: "透明度",
              animateType: "opacity",
              triggerType: "hover",
              variable: {
                hoverOpacity: 0.5
              },
              animateClass: "cx_hover__opacity",
              animateLeaveClass: "cx_hover_leave__opacity",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-opacity"
            },
            {
              name: "背景",
              animateType: "background",
              triggerType: "hover",
              background: [],
              variable: {
                hoverBackground: "",
                hoverBackgroundSize: ""
              },
              animateClass: "cx_hover__background",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-bg-color"
            },
            {
              name: "边框",
              animateType: "border",
              triggerType: "hover",
              border: {},
              variable: {
                hoverBorderWidth: "",
                hoverBorderColor: "",
                hoverBorderStyle: ""
              },
              animateClass: "cx_hover__border",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-border"
            },
            {
              name: "圆角",
              animateType: "borderRadius",
              triggerType: "hover",
              aborderRadius: {},
              variable: {
                hoverBorderRadius: ""
              },
              animateClass: "cx_hover__borderRadius",
              animateLeaveClass: "cx_hover_leave__borderRadius",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-full-screen1"
            },
            {
              name: "阴影",
              animateType: "boxShadow",
              triggerType: "hover",
              aboxShadow: {},
              variable: {
                hoverBoxShadow: ""
              },
              animateClass: "cx_hover__boxShadow",
              animateLeaveClass: "cx_hover_leave__boxShadow",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-shadow"
            }
          ]
        },
        {
          type: "type4",
          list: [
            {
              name: "宽高",
              animateType: "size",
              triggerType: "hover",
              variable: {
                hoverWidth: "200px",
                hoverHeight: "200px",
                hoverMarginTop: "0px",
                hoverMarginLeft: "0px"
              },
              animateClass: "cx_hover__size",
              animateLeaveClass: "cx_hover_leave__size",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-w-h1"
            }
          ]
        },
        {
          type: "type5",
          list: [
            {
              name: "滚动页面",
              animateType: "pageScroll",
              triggerType: "hover",
              variable: {
                target: null // 滚动到当前组件的位置  target为组件的 ids
              },
              animateClass: "",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-page-scroll2"
            }
          ]
        }
      ],
      clickAnimateStyles: [
        {
          type: "type1",
          list: [
            {
              name: "飞入",
              animateType: "fadeIn",
              triggerType: "click",
              animateClass: "cx_click__fadeIn_left",
              variable: null,
              direction: "left",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-fly"
            },
            {
              name: "移动",
              animateType: "move",
              triggerType: "click",
              variable: {
                clickLeft: "100px",
                clickTop: "100px"
              },
              animateClass: "cx_click__move",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-move"
            },
            {
              name: "变换",
              animateType: "rotateScale",
              triggerType: "click",
              variable: {
                clickRotate: "90deg",
                clickScale: 1.5
              },
              animateClass: "cx_click__rotate_scale",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-scale"
            },
            {
              name: "图片缩放",
              animateType: "imageScale",
              triggerType: "click",
              variable: {
                clickImageScale: 1.5
              },
              animateClass: "cx_click__image_scale",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-scale--picture"
            },
            {
              name: "图标替换",
              animateType: "iconReplace",
              triggerType: "click",
              icon:{
                src:'',
                type: 'icon',
                color:'#000',
                colorIsThemeColor: false
              },
              variable: {
                clickIconSrcType: `options_iconSrcType_0`, // 图标类型 0 是iconSrc   1是hoverIconSrc  2是clickIconSrc
                clickIconColor: '#fff',
              },
              animateClass: "cx_click__icon_replace",
              animateLeaveClass: "cx_click_leave__icon_replace",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-replace"
            }
          ]
        },
        {
          type: "type2",
          list: [
            {
              name: "文字颜色",
              animateType: "fontColor",
              triggerType: "click",
              variable: {
                clickColor:'var_Color_page.themeColor'
              },
              animateClass: "cx_click__fontColor",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-color"
            },
            {
              name: "文字大小",
              animateType: "fontSize",
              triggerType: "click",
              variable: {
                clickFontSize: "18px"
              },
              animateClass: "cx_click__fontSize",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-text-2"
            },
            {
              name: "文字粗细",
              animateType: "fontWeight",
              triggerType: "click",
              variable: {
                clickFontWeight: "600"
              },
              animateClass: "cx_click__fontWeight",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-text-bold1"
            }
          ]
        },
        {
          type: "type3",
          list: [
            {
              name: "透明度",
              animateType: "opacity",
              triggerType: "click",
              variable: {
                clickOpacity: 0.5
              },
              animateClass: "cx_click__opacity",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-opacity"
            },
            {
              name: "背景",
              animateType: "background",
              triggerType: "click",
              background: [],
              variable: {
                clickBackground: "",
                clickBackgroundSize: ""
              },
              animateClass: "cx_click__background",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-bg-color"
            },
            {
              name: "边框",
              animateType: "border",
              triggerType: "click",
              border: {},
              variable: {
                clickBorderWidth: "",
                clickBorderColor: "",
                clickBorderStyle: ""
              },
              animateClass: "cx_click__border",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-border"
            },
            {
              name: "圆角",
              animateType: "borderRadius",
              triggerType: "click",
              aborderRadius: {},
              variable: {
                clickBorderRadius: ""
              },
              animateClass: "cx_click__borderRadius",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-full-screen1"
            },
            {
              name: "阴影",
              animateType: "boxShadow",
              triggerType: "click",
              aboxShadow: {},
              variable: {
                clickBoxShadow: ""
              },
              animateClass: "cx_click__boxShadow",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-shadow"
            }
          ]
        },
        {
          type: "type4",
          list: [
            {
              name: "宽高",
              animateType: "size",
              triggerType: "click",
              variable: {
                clickWidth: "200px",
                clickHeight: "200px",
                clickMarginTop: "0px",
                clickMarginLeft: "0px"
              },
              animateClass: "cx_click__size",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-w-h1"
            }
          ]
        },
        {
          type: "type5",
          list: [
            {
              name: "滚动页面",
              animateType: "pageScroll",
              triggerType: "click",
              variable: {
                target: null // 滚动到当前组件的位置  target为组件的 ids
              },
              animateClass: "",
              animateLeaveClass: "",
              animateDuration: 1000, //单位ms
              animateDelay: 0,
              animationIterationCount: 2,
              iconClass: "icon-portal-page-scroll2"
            }
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.animates-lists:not(.no-middle-line):before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  content: "";
  background-color: #f0f0f0;
  width: 1px;
}
.animates-lists > div {
  flex: 1;
}
.animates-lists-ul {
  padding: 6px;
  box-sizing: border-box;
}
.aniamte-list-wrap {
  .animate-types {
    &:not(:last-child) {
      border-bottom: 1px solid #f0f0f0;
    }
  }
}
.animates-lists-li {
  padding: 6px 9px;
  height: 36px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background-color: var(--themeColorSelectBg);
    color: var(--themeColor);
    .icon:before {
      color: var(--themeColor);
    }
  }
  .icon {
    font-size: 16px;
    margin-right: 4px;
  }
  span {
    display: inline-block;
    vertical-align: middle;
  }
  .icon-portal-text-bold1 {
    transform: scale(0.95);
  }
}
</style>
